export interface InstallmentsData {
  type: InstallmentsType;
  paymentsCount: number;
  firstPayment: number;
}

export enum InstallmentsType {
  FIXED = 'fixed',
  EQUALLY = 'equally',
}
